import { saveAs } from 'file-saver';

export function downloader(source$: () => Promise<unknown>, fileType: string, fileName: string) {
  return source$().then(res => {
    const blob = new Blob([res as BlobPart], { type: fileType });
    saveAs(blob, fileName);
  });
}
